import { render, staticRenderFns } from "./payment-failed.vue?vue&type=template&id=5c58e0dc&"
import script from "./payment-failed.vue?vue&type=script&lang=js&"
export * from "./payment-failed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports